export default __webpack_public_path__ + "static/media/arrowDown.f9561438.svg";